import { Breadcrumb } from './../../shared/domain/breadcrum.entity';
import { User } from './../../shared/services/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { IState } from './../../shared/store/root.reducer';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  breadcrumb: Breadcrumb;
  breadcrumbCssClass: string;
  currentUser: User;
  subscriptions: Subscription[] = [];

  constructor(
    private store: Store<IState>,
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.store.pipe(select((state: IState) => state.breadcrumb))
      .subscribe(breadcrumb => {
        this.breadcrumb = breadcrumb;
    }));

    this.subscriptions.push(this.store.pipe(select((state: IState) => state.currentUser)).subscribe(currentUser => {
      if (currentUser && currentUser.contactId !== 0) {
        this.currentUser = currentUser;
      }
    }));

    this.subscriptions.push(this.store.pipe(select((state: IState) => state.print))
      .subscribe(printState => {
        this.breadcrumbCssClass = printState.breadcrumbCssClass;
    }));
  }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      subscription.unsubscribe();
    });
  }
}
